import { Link } from 'react-router-dom';
import { COURSES } from '../../data/courses';
import ImageSlot from '../ui/ImageSlot';

/**
 * Featured Courses — 3x2 grid on the homepage with image-slot covers,
 * provider tag, duration, learners count, and a "Free" CTA.
 */
export default function FeaturedCourses() {
  return (
    <section className="lc-section" style={{ background: 'var(--bg-soft)' }}>
      <div className="lc-container">
        <div className="flex justify-between items-end" style={{ marginBottom: 40 }}>
          <div>
            <span className="lc-eyebrow">Featured courses</span>
            <h2 className="mt-3.5">Real courses, taught by a tutor who never tires.</h2>
          </div>
          <Link to="/courses" className="lc-link" style={{ color: 'var(--ink-2)' }}>Browse all 15+ courses →</Link>
        </div>

        <div className="grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
          {COURSES.map((c) => (
            <Link
              key={c.slug}
              to={`/courses/${c.slug}`}
              className="lc-card flex flex-col overflow-hidden"
              style={{ padding: 0 }}
            >
              <div className="relative overflow-hidden" style={{ height: 160, background: c.color }}>
                <ImageSlot
                  id={`course-cover-${c.slug}`}
                  style={{ position: 'absolute', inset: 0 }}
                  shape="rect"
                  src={c.img}
                  placeholder={`Drop ${c.title} thumbnail`}
                />
                <div className="absolute inset-0 pointer-events-none"
                  style={{ background: 'linear-gradient(180deg, rgba(0,0,0,0) 50%, rgba(0,0,0,0.45) 100%)' }} />
                <span className="absolute font-bold tracking-wider text-white pointer-events-none"
                  style={{ top: 12, left: 12, background: 'rgba(11,31,56,0.92)', padding: '4px 8px', borderRadius: 4, fontSize: 10 }}>
                  {c.level.toUpperCase()}
                </span>
                <span className="absolute font-bold pointer-events-none"
                  style={{ top: 12, right: 12, background: 'var(--yellow)', color: 'var(--navy)', padding: '4px 8px', borderRadius: 4, fontSize: 10 }}>
                  {c.icon}
                </span>
              </div>
              <div className="flex flex-col flex-1" style={{ padding: 20 }}>
                <div className="font-semibold uppercase tracking-wider" style={{ fontSize: 11, color: 'var(--muted)' }}>{c.provider}</div>
                <h4 className="mt-1.5">{c.title}</h4>
                <div className="flex items-center mt-3.5" style={{ gap: 14, fontSize: 12, color: 'var(--muted)' }}>
                  <span className="inline-flex items-center gap-1">⏱ {c.duration}</span>
                  <span className="inline-flex items-center gap-1">👥 {c.learners}</span>
                </div>
                <div className="flex justify-between items-center mt-4 pt-4" style={{ borderTop: '1px solid var(--line)' }}>
                  <span className="font-bold" style={{ fontSize: 14, color: 'var(--green-2)' }}>Free</span>
                  <span className="font-semibold" style={{ fontSize: 13, color: 'var(--ink)' }}>Start course →</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
